<template>
    <div>
        <HeadDetailsGama @nextstatus="$emit('nextstatus')"  v-on:save="onSubmit" :btnCanceSave="!flDisable" :titleHead="'Lista de Chamados'"></HeadDetailsGama>
        <div id="body-visit" class="mt-4 ml-2">
            <div class="row mt-4 ml-3 obs-margem">
            <p  class=" subtitle-visit mt-2">Avaliação do Cliente</p>
            <div class="button-edit-avaliacao" >
            <b-button :disabled="flDisable" @click="editarAvaliacao = !editarAvaliacao" class="button-edit" :class="{'button-edit-actived': editarAvaliacao }" id="show-btn"><i class="fas fa-pencil-alt pencil-edit"></i>Editar avaliação</b-button>
            </div>
            </div>
            <table class="table table-bordered">
                <thead class="thead-back">
                    <tr>
                    <th scope="col">Descrição</th>
                    <th width="10%" scope="col" class="text-center">Ótimo</th>
                    <th width="10%" scope="col" class="text-center">Bom</th>
                    <th width="10%" scope="col" class="text-center">Regular</th>
                    <th width="10%" scope="col" class="text-center">Ruim</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                    <th scope="row" class="table-row" >Qualidade dos serviços prestados</th>
                    <td @click="atualizaAvalicaoMatriz(0, 0)" >
                        <div v-if="avaliacaoMatriz[0][0]" class="background-check" >
                            <div class="check-icon" >
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(0, 1)">
                        <div v-if="avaliacaoMatriz[0][1]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(0, 2)">
                        <div v-if="avaliacaoMatriz[0][2]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(0, 3)">
                        <div v-if="avaliacaoMatriz[0][3]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    </tr>
                    <tr>
                    <th scope="row" class="table-row">Tempo de resposta para atendimento</th>
                    <td @click="atualizaAvalicaoMatriz(1, 0)">
                        <div v-if="avaliacaoMatriz[1][0]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(1, 1)">
                        <div v-if="avaliacaoMatriz[1][1]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(1, 2)">
                        <div v-if="avaliacaoMatriz[1][2]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(1, 3)">
                        <div v-if="avaliacaoMatriz[1][3]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    </tr>
                    <tr>
                    <th scope="row" class="table-row">Comportamento, cordialidade</th>
                    <td @click="atualizaAvalicaoMatriz(2, 0)">
                        <div v-if="avaliacaoMatriz[2][0]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(2,1)" >
                        <div v-if="avaliacaoMatriz[2][1]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(2,2)">
                        <div v-if="avaliacaoMatriz[2][2]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(2,3)">
                        <div v-if="avaliacaoMatriz[2][3]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    </tr>
                    <tr>
                    <th scope="row" class="table-row">Organização e limpeza</th>
                    <td @click="atualizaAvalicaoMatriz(3,0)">
                        <div v-if="avaliacaoMatriz[3][0]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(3,1)">
                        <div v-if="avaliacaoMatriz[3][1]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(3,2)">
                        <div v-if="avaliacaoMatriz[3][2]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    <td @click="atualizaAvalicaoMatriz(3,3)">
                        <div v-if="avaliacaoMatriz[3][3]" class="background-check">
                            <div class="check-icon">
                                <i class="fas fa-check" style="color: white;"></i>
                            </div>
                        </div>
                    </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    </template>
<script>
import ratingCustomer from './ratingCustomer'
export default ratingCustomer
</script>
    <style scoped>
    .subtitle-visit{
        font-size: 18px;
        color: #008148;
        font-weight: bold;
    }
    .label-visit{
        font-size: 15px;
        color: black;
        margin-bottom: 0px;
    }
    .file-delete-vistoria{
        height: 30px;
        width: 30px;
        position: absolute;
        top: 0px;
        right: 0px;
        display: flex;
        border-radius: 0px 10px 0px 10px;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        color: white;
        font-weight: bold;
        background: red;
    }
    .pdf-vistoria-download{
        height: 30px;
        width: 30px;
        position: absolute;
        top: 0px;
        left: 0px;
        display: flex;
        border-radius: 10px 0px 10px 0px;
        cursor: pointer;
        justify-content: center;
        align-items: center;
        color: white;
        font-weight: bold;
        background: #008148;
    }
    .import-ar-button{
     border: none;
     height: 40px;
     background: white;
     border-radius: 10px;
     font-size: 12px;
     padding: 10px;
     font-weight: bold;
     color: gray;
    }
    .input-invisible{
        visibility: hidden;
    }
    .pdfVistoria{
        height: 100px;
        width: 1000px;
        margin-bottom: 15px;
    }
    .pdfVistoria-footer{
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        color: rgb(31, 31, 31);
        border-radius: 0px 0px 10px 10px;
        position: absolute;
        bottom: 0px;
        background: rgba(180, 180, 180, 0.493);
        width: 100%;
    }
    .pdf-vistoria{
        height: 140px;
        width: 250px;
        display: flex;
        justify-content: center;
        position: relative;
        background: #F6F6F6;
        align-items: center;
        border: 1px dashed gray;
        border-radius: 10px;
    }
    .des-file-pdf{
        font-size: 14px;
    }
    .icone-pdf{
        font-size: 25px;
        margin-bottom: 8px;
    }
    .vistoria_container{
        height: 200px;
        width: 250px;
    }
    .subtitle_Dados{
        grid-area: subtitle_Dados;
        color: #008148;
        font: normal normal 600 18px/24px Segoe UI;
        height: 24px;
    }
    .triagem_container{
        display: flex;
        background-color: #DEDEDE;
        align-items: center;
        border-radius: 6px;
    }
    .background-check{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .check-icon{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        position: center;
        background-color: #008148;
    }
    .label-cortesia{
        font-size: 15px;
        color: black;
        margin-bottom: 0px;
        padding: 0.7% 0% 0% 2.5%;
    }
    .label-manutencao{
        font-size: 15px;
        color: black;
        margin-bottom: 0px;
        padding: 0.5% 0% 0% 1.2%;
    }
    .input-visit{
        width: 100%;
        height: 35px;
        background-color: 100%;
        border: 1px solid #D4D9DE;
        border-radius: 5px;
        outline: none;
    }
    .check-container-garantia{
        display: flex;
        height: 2rem;
    }
    .check-container-cortesia{
        display: flex;
        height: 1.5rem;
        justify-content: flex-start;
    }
    .check-container-manutecao{
        display: flex;
        height: 1.5rem;
        justify-content: flex-start;
    }
    .checkcolor{
        accent-color: #008148;
        width: 1.2rem;
    }
    .simCheck{
        display: flex;
        align-items: center;
        text-align: left;
        color: #fff;
        padding-left: 0.5rem;
    }

    .input[type=checkbox]{
        transform: scale(2);
        margin: 10px;
        cursor:pointer;
        background-color: #fff;
    }
    .obs-margem{
        margin-left: 0%;
        position: relative;
    }
    .button-edit{
        margin-right: 1rem;
        width: 169px;
        height: 37px;
        background: #DEDEDE 0% 0% no-repeat padding-box;
        border-color: transparent;
        border-radius: 4px;
        font: normal normal normal 16px/21px Segoe UI;
        color: #3D3D3D;
    }
    .fa-pencil-alt{
        padding-right: 10px;
    }
    .button-edit-avaliacao {
        justify-content: end;
        display: flex;
        position: absolute;
        right: 1%;
    }
    .tabela-visit{
        width: 100%;
    }
    .thead-back{
        background-color: #008148;
        font: normal normal 600 18px/24px Segoe UI;
        color: #FFFFFF;
    }
    .table-row{
        text-align: left;
        font: normal normal normal 16px/21px Segoe UI;
        color: #2A2A2A;
    }
    .button-edit-actived{
        background: #008148;
        color: white;
    }
    </style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/ratingCustomer/ratingCustomer.vue